import React from "react";
import { useNavigate } from "react-router-dom";
import facebook from '../../src/images/homepage/footer/facebook.png';
import footerImg from "../../src/images/homepage/footer/footer.png";
import instagram from '../../src/images/homepage/footer/instagram.png';
import youtube from '../../src/images/homepage/footer/youtube.png';
import twitter from '../../src/images/homepage/footer/twitter.png';

const Footer = ({ footer }) => {
  const navigate = useNavigate();

  const currentYear = new Date().getFullYear();  

  const handleNavigation = (type) => {
    navigate(`/service?inspectionType=${encodeURIComponent(type)}`);
  };

  const socialIcons = [
    { src: facebook, link: "https://www.facebook.com/share/1AhBm5rC7f/" },
    { src: twitter, link: "https://x.com/i/flow/login?redirect_after_login=%2FCarvetPro" },
    { src: instagram, link: "https://www.instagram.com/carvetproindia?igsh=MWVraHVydzUydDc5aA==" },
    { src: youtube, link: "https://youtube.com/@carvetproindia?si=LvAdbNabFiNvC8Pc" },
  ];

  return (
    <section className="bg-[#1F1F1F] w-full h-auto pb-8">
      <div className="flex flex-col items-center justify-center pt-20 px-4">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-24 lg:items-start item-center lg:justify-around justify-center w-full lg:max-w-6xl">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center text-center lg:text-left">
            <img src={footerImg} alt="footer logo" className="mb-4 w-30 h-20" />
            <p className="text-[#D1D1D1] text-[16px] max-w-[300px]">
              {footer?.tagline || 'Your trusted partner for expert vehicle inspections and road-ready confidence.'}
            </p>
            <div className="flex items-center justify-center gap-5 mt-7">
              {socialIcons.map((icon, index) => (
                <a
                  key={index}
                  href={icon.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#313131] rounded-md p-4 flex items-center justify-center shadow-md hover:bg-opacity-80 transition-all duration-300"
                >
                  <img src={icon.src} alt="social media icon" className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Our Services */}
          <div className="text-[#ffff] text-center lg:text-left">
            <h2 className="text-xl font-bold mb-4">Our Services</h2>
            <ul className="list-none">
              <li className="mb-2 cursor-pointer" onClick={() => handleNavigation("Pre Delivery Inspection")}>Pre Delivery Inspection</li>
              <li className="mb-2 cursor-pointer" onClick={() => handleNavigation("Used Car Inspection")}>Used Car Inspection</li>
              <li className="mb-2 cursor-pointer" onClick={() => handleNavigation("Pre-Trip Inspection")}>Pre-Trip Inspection</li>
              <li>Driver Assistance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-[#ffff] text-center lg:text-left">
            <h2 className="text-xl font-bold mb-4">Contact Us</h2>
            <ul className="list-none">
              <li className="mb-2">{footer?.email || 'info@carvetpro.com'}</li>
              <li className="mb-2">{footer?.phone || '+91 96115 60076'}</li>
              <li>{footer?.address || 'Bangalore, India 560100'}</li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <hr className="max-w-[1100px] w-full border-gray-300 my-8" />
        <p className="text-[#FFFF] text-center">
          CARVETPRO © All rights reserved. Copyright {currentYear}
        </p>
      </div>
    </section>
  );
};

export default Footer;